import { render, staticRenderFns } from "./BatchUploadExpress.vue?vue&type=template&id=21179e23&scoped=true&"
import script from "./BatchUploadExpress.vue?vue&type=script&lang=js&"
export * from "./BatchUploadExpress.vue?vue&type=script&lang=js&"
import style0 from "./BatchUploadExpress.vue?vue&type=style&index=0&id=21179e23&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21179e23",
  null
  
)

export default component.exports